import React, { useState } from 'react';
import { Button, Divider, Drawer, makeStyles, Tab, Tabs, Typography } from '@material-ui/core'
import { COLOR_BACKGROUND_WARM, COLOR_MIDDLE_GRAY } from "../styles/colors";
import Loader from '../atoms/Loader';
import CloseButton from '../atoms/CloseButton';
import EvaluationDrawerContent from '../molecules/EvaluationDrawerContent';

const useStyles = makeStyles(theme => ({
  indicator: {
    display: 'none',
  },
  evaluationBtn: {
    border: `2px solid ${COLOR_MIDDLE_GRAY}`,
    borderRadius: '30px',
    boxShadow: 'none',
    backgroundColor: COLOR_BACKGROUND_WARM,
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 600,
    padding: `${theme.spacing(1.5)}px ${theme.spacing(3)}px`,
    textTransform: 'initial',

    '&:hover': {
      backgroundColor: COLOR_BACKGROUND_WARM,
      boxShadow: 'none',
      fontWeight: 800,
      padding: `${theme.spacing(1.5)}px ${theme.spacing(2.825)}px`,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      textAlign: 'center',
      justifyContent: 'space-between',
    },
  },
  evaluationReportDrawer: {
    width: '40%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  evaluationReportDrawerHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
  },
  evaluationReportDrawerHeaderTitle: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 600,
  },
  evaluationReportDrawerHeaderCloseButton: {
    width: '20px',
    height: '20px',
    cursor: 'pointer',
  },
}), { name: Evaluation.name });

export default function Evaluation() {
  const classes = useStyles();
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);

  function onClose() {
    setDrawerOpen(false);
  }


  return (
  <div>
    <Button variant="contained" 
      className={classes.evaluationBtn}
      endIcon={
        <img
          src="/images/teams/auburn-tigers.png"
          alt="Auburn Tigers"
          width={20}
          height={20}
        />
      }
      onClick={() => setDrawerOpen(true)}
    >
      Evaluation
    </Button>
    <Drawer
      classes={{ paper: classes.evaluationReportDrawer }}
      anchor='right'
      open={drawerOpen}
      onClose={onClose}
    >
      <EvaluationDrawerContent onClose={onClose}/>
    </Drawer>
  </div>
  );
};